var snapshotFurnitureState = require('./object-utils').snapshotFurnitureState;

function applySeatSnapToFabricObject(obj, snap) {
    obj.set({ left: snap.left, top: snap.top, radius: snap.radius });
    return snap;
}

function applyFurnitureSnapToFabricObject(obj, snap) {
    obj.gridX = snap.gridX;
    obj.gridY = snap.gridY;
    obj.widthCells = snap.widthCells;
    obj.heightCells = snap.heightCells;
    obj.set({
        left: snap.left,
        top: snap.top,
        width: snap.width,
        height: snap.height,
        scaleX: 1,
        scaleY: 1
    });
    if (obj._lastValid) {
        Object.assign(obj._lastValid, snapshotFurnitureState(obj));
    }
    return {
        left: snap.left,
        top: snap.top,
        width: snap.width,
        height: snap.height
    };
}

module.exports = {
    applySeatSnapToFabricObject: applySeatSnapToFabricObject,
    applyFurnitureSnapToFabricObject: applyFurnitureSnapToFabricObject
};
